import React, { useState } from "react";
import "../ViewNotification.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux-store/store";
import {
  GetAllNotification_M3,
  RejectNotification,
} from "../../../../../api/notifyapi/Notifyapi";
import {
  IFilterModel,
  NotificationActions,
} from "../../../../../slices/NotificationSlice";
import { Spin } from "antd";
import Loader from "../../../loader/Loader";

interface RejectSectioProps {
  onClose: () => void;
}

const RejectSection: React.FC<RejectSectioProps> = ({ onClose }) => {
  const dispatch = useDispatch<AppDispatch>();
  const data = useSelector((state: RootState) => state.notification.editData);
  const { searchFilter } = useSelector(
    (state: RootState) => state.notification
  );
  const [rejectComment, setRejectComment] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleGoBack = (): void => {
    onClose();
  };

  const handleChanges = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    setRejectComment(e.target.value);
  };

  const handleToReject = async (): Promise<void> => {
    try {
      if (data) {
        setIsLoading(true);
        dispatch(
          RejectNotification({
            comments: rejectComment,
            state: "REJECTED",
            performedBy: data.assignedUser[0],
            notificationIDs: [data.notificationID],
          })
        ).then(() => {
          setIsLoading(false);
          dispatch(NotificationActions.UpdateViewPopup(false));
          if (searchFilter.globalSearch.value) {
            let lQuery: IFilterModel = {
              filters: searchFilter.globalSearchApiQuery.filters,
              isAscending: false,
              currentPageSize: searchFilter.apiQuery.currentPageSize,
              pageSize: searchFilter.apiQuery.pageSize,
              page: 1, //First time always get page 1
              isOr: true,
              isPageChanged: "",
              sortField: "",
            };

            dispatch(GetAllNotification_M3(lQuery));
          } else {
            dispatch(GetAllNotification_M3(searchFilter.apiQuery));
          }
        });
      }
    } catch (error) {}
  };
  return (
    <>
      <div className="view-modal-body reject-modal-body">
        <div className="view-notification-heading-element">
          Rejection Details
        </div>
        <div className="rejact-comment-section-container">
          <div className="reject-comment-heading">
            Please add a comment for reason of rejection :
          </div>
          <div className="reject-textarea-container">
            <textarea
              className="reject-textarea"
              onChange={(e) => handleChanges(e)}
              style={{ resize: "none" }}
            />
          </div>
          <div className="label-element reject-textarea-info">
            Character Limit can come here
          </div>
          <div
            className="label-element reject-textarea-note"
            style={{ alignItems: "flex-end" }}
          >
            Note: Rejecting a notification will send it’s status back to draft
          </div>
        </div>
      </div>
      <div className="view-modal-footer reject-footer">
        <button
          disabled={rejectComment.length === 0}
          className={`popup-create-btn ${
            rejectComment.length === 0 ? " disabled-button-style" : ""
          }`}
          onClick={() => handleToReject()}
        >
          Reject
          {isLoading ? <Loader /> : <></>}
        </button>
        <button className="popup-create-btn outline-btn" onClick={handleGoBack}>
          Go Back
        </button>
      </div>
    </>
  );
};

export default RejectSection;
